const VerticalAlignment ={
    TOP: 'top',
    BOTTOM: 'bottom',
    CENTER: 'center'
}

export default VerticalAlignment
